




















































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePersetujuanLaparotomi } from "@/store/modules/PersetujuanLaparotomiStore";
import PersetujuanLaparotomiSvc from "@/services/PersetujuanLaparotomi";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanLaparotomi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: "ranap" }) context!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean { return this.isReadOnly(); }

  showForm = false;
  isEditing = false;
  selectedItem: any = null;
  modalTtd = false;
  modalMark = false;
  markRole = "";
  markName = "";
  signRole = "";
  saving = false;
  deleting = false;
  formValid = false;
  menuTanggal = false;
  menuJam = false;
  menuTglInfo = false;
  menuJamInfo = false;
  panels: number[] = [0, 1, 2, 3, 4];

  form: any = this.getEmptyForm();

  tableHeaders = [
    { text: "Nomor", value: "nomor", width: "160" },
    { text: "Diagnosis", value: "diagnosis_praoperasi" },
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120" },
    { text: "Keputusan", value: "is_setuju", width: "100" },
    { text: "Status TTD", value: "status_ttd", width: "120" },
  ];

  asaOptions = ["I", "II", "III", "IV", "V", "VI"];
  sifatOperasiOptions = [
    { text: "Elektif", value: "elektif" },
    { text: "Urgensi (24 jam)", value: "urgensi" },
    { text: "Cito (6 jam)", value: "cito" },
    { text: "Emergensi (<1 jam)", value: "emergensi" },
  ];
  icd9Options = [
    { text: "54.11 — Laparotomi Eksplorasi", value: "54.11" },
    { text: "54.12 — Re-laparotomi", value: "54.12" },
    { text: "54.19 — Laparotomi Lain", value: "54.19" },
  ];
  insisiOptions = [
    { text: "Mediana", value: "mediana" },
    { text: "Transversal", value: "transversal" },
    { text: "Pfannenstiel", value: "pfannenstiel" },
    { text: "Kocher", value: "kocher" },
    { text: "McBurney-extended", value: "mcburney_extended" },
    { text: "Lain", value: "lain" },
  ];
  anestesiOptions = [
    { text: "Umum", value: "umum" },
    { text: "Spinal", value: "spinal" },
    { text: "Epidural", value: "epidural" },
    { text: "Kombinasi", value: "kombinasi" },
  ];
  hubunganOptions = [
    { text: "Pasien Sendiri", value: "pasien-sendiri" },
    { text: "Suami", value: "suami" },
    { text: "Istri", value: "istri" },
    { text: "Ayah", value: "ayah" },
    { text: "Ibu", value: "ibu" },
    { text: "Anak (≥18 thn)", value: "anak" },
    { text: "Saudara Kandung (≥18 thn)", value: "saudara" },
    { text: "Wali Sah", value: "wali" },
  ];
  rencanaPenolakanOptions = [
    { text: "Pulang APS", value: "pulang_aps" },
    { text: "Pindah RS", value: "pindah_rs" },
    { text: "Lanjut Konservatif", value: "konservatif" },
    { text: "Re-evaluasi", value: "re_evaluasi" },
  ];

  mounted() {
    storePersetujuanLaparotomi.getByRegister(this.register);
    storePersetujuanLaparotomi.loadMasters();
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  getEmptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || null,
      context: this.context,
      diagnosis_praoperasi: "",
      diagnosis_icd10: "",
      diagnosis_banding: "",
      asa_status: null,
      asa_emergency: false,
      sifat_operasi: "",
      jenis_insisi: null,
      jenis_anestesi_rencana: null,
      riwayat_alergi: storePasien.identitasPasien?.alergi || "Tidak ada", // RAN-051: prefill kanonik
      riwayat_operasi: "",
      prosedur_icd9cm: "",
      info_diagnosis: "",
      info_dasar_diagnosis: "",
      info_tindakan: "Laparotomi",
      info_indikasi: "",
      info_tata_cara: "",
      info_tujuan: "",
      info_risiko: "",
      info_komplikasi: "",
      info_prognosis: "",
      info_alternatif: "",
      info_risiko_bila_tidak: "",
      info_perluasan_intraop: "",
      info_lain: "",
      risiko_checklist: [],
      komplikasi_checklist: [],
      alternatif_checklist: [],
      estimasi_durasi: "",
      estimasi_lama_rawat: "",
      kebutuhan_darah: "",
      tgl_info: localISODate(),
      jam_info: new Date().toTimeString().substr(0, 5),
      tempat_info: "",
      bahasa: "id-ID",
      is_setuju: null,
      alasan_penolakan: "",
      tolak_paham_risiko: false,
      tolak_paham_alternatif: false,
      tolak_tanggung_jawab: false,
      rencana_pasca_penolakan: null,
      dpjp_user_id: null,
      penyetuju_nama: storePasien.identitasPasien?.nama || "",
      penyetuju_hubungan: "pasien-sendiri",
      penyetuju_nik: "",
      penyetuju_jenis_kelamin: null,
      penyetuju_alamat: "",
      saksi_keluarga_nama: "",
      saksi_rs_user_id: null,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate(),
      jam_tanda_tangan: new Date().toTimeString().substr(0, 5),
    };
  }

  get loading() { return storePersetujuanLaparotomi.loading; }
  get items() { return storePersetujuanLaparotomi.items; }
  get masters() { return storePersetujuanLaparotomi.masters; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }

  applyAutofill() {
    const a = this.masters.autofill || {};
    Object.keys(a).forEach((key: string) => {
      if (!this.form[key]) this.form[key] = a[key];
    });
  }

  selectItem(item: any) { this.selectedItem = item; }

  openCreateForm() {
    this.form = this.getEmptyForm();
    this.showForm = true;
  }

  startEdit() {
    const c = this.selectedItem;
    this.form = {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: c.unit_id || this.stateuser?.unit_id,
      context: c.context || this.context,
      diagnosis_praoperasi: c.diagnosis_praoperasi,
      diagnosis_icd10: c.diagnosis_icd10 || "",
      diagnosis_banding: c.diagnosis_banding || "",
      asa_status: c.asa_status,
      asa_emergency: c.asa_emergency,
      sifat_operasi: c.sifat_operasi,
      jenis_insisi: c.jenis_insisi,
      jenis_anestesi_rencana: c.jenis_anestesi_rencana,
      riwayat_alergi: c.riwayat_alergi || "Tidak ada",
      riwayat_operasi: c.riwayat_operasi || "",
      prosedur_icd9cm: c.prosedur_icd9cm,
      info_diagnosis: c.info_diagnosis,
      info_dasar_diagnosis: c.info_dasar_diagnosis,
      info_tindakan: c.info_tindakan,
      info_indikasi: c.info_indikasi,
      info_tata_cara: c.info_tata_cara,
      info_tujuan: c.info_tujuan,
      info_risiko: c.info_risiko,
      info_komplikasi: c.info_komplikasi,
      info_prognosis: c.info_prognosis,
      info_alternatif: c.info_alternatif,
      info_risiko_bila_tidak: c.info_risiko_bila_tidak,
      info_perluasan_intraop: c.info_perluasan_intraop || "",
      info_lain: c.info_lain || "",
      risiko_checklist: c.risiko_checklist || [],
      komplikasi_checklist: c.komplikasi_checklist || [],
      alternatif_checklist: c.alternatif_checklist || [],
      estimasi_durasi: c.estimasi_durasi || "",
      estimasi_lama_rawat: c.estimasi_lama_rawat || "",
      kebutuhan_darah: c.kebutuhan_darah || "",
      tgl_info: c.tgl_info,
      jam_info: c.jam_info,
      tempat_info: c.tempat_info || "",
      bahasa: c.bahasa || "id-ID",
      is_setuju: c.is_setuju,
      alasan_penolakan: c.alasan_penolakan || "",
      tolak_paham_risiko: c.tolak_paham_risiko,
      tolak_paham_alternatif: c.tolak_paham_alternatif,
      tolak_tanggung_jawab: c.tolak_tanggung_jawab,
      rencana_pasca_penolakan: c.rencana_pasca_penolakan,
      dpjp_user_id: c.dpjp?.id || null,
      penyetuju_nama: c.penyetuju_nama,
      penyetuju_hubungan: c.penyetuju_hubungan || "pasien-sendiri",
      penyetuju_nik: c.penyetuju_nik || "",
      penyetuju_jenis_kelamin: c.penyetuju_jenis_kelamin,
      penyetuju_alamat: c.penyetuju_alamat || "",
      saksi_keluarga_nama: c.saksi_keluarga_nama || "",
      saksi_rs_user_id: c.saksi_rs?.id || null,
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: c.tgl_tanda_tangan,
      jam_tanda_tangan: c.jam_tanda_tangan,
    };
    this.isEditing = true;
  }

  cancelForm() {
    this.showForm = false;
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = { ...this.form };
      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PersetujuanLaparotomiSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PersetujuanLaparotomiSvc.create(payload);
      }
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Laparotomi berhasil disimpan");
        this.showForm = false;
        this.isEditing = false;
        this.selectedItem = null;
        this.form = this.getEmptyForm();
        storePersetujuanLaparotomi.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  // Permissions
  get canEdit() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }
  get canDelete() {
    if (this.readOnly || !this.selectedItem) return false;
    return !alasanTtdMengunciHapus(
      this.selectedItem.creator_user_id,
      [
        ...slotTandaTanganDokumen(this.selectedItem.signed_dpjp, this.selectedItem.signature_dpjp),
        { ditandatangani: this.selectedItem.signed_penyetuju, penandaTanganId: null },
        { ditandatangani: this.selectedItem.signed_saksi_keluarga, penandaTanganId: null },
        ...slotTandaTanganDokumen(this.selectedItem.signed_saksi_rs, this.selectedItem.signature_saksi_rs)
      ],
      this.stateuser?.id
    );
  }
  get canSignDpjp() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_dpjp) return false;
    return this.selectedItem.dpjp?.id == this.stateuser?.id;
  }
  get canSignSaksiRs() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_saksi_rs) return false;
    if (this.selectedItem.saksi_rs && this.selectedItem.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }
  get canMarkPenyetuju() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_penyetuju;
  }
  get canMarkSaksiKeluarga() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_saksi_keluarga;
  }

  get markLabel() {
    return ({
      penyetuju: "Yang Menyatakan",
      saksi_keluarga: "Saksi Keluarga",
    } as any)[this.markRole] || "";
  }

  openMarkPenyetuju() {
    this.markRole = "penyetuju";
    this.markName = this.selectedItem?.penyetuju_nama || "";
    this.modalMark = true;
  }
  openMarkSaksiKeluarga() {
    this.markRole = "saksi_keluarga";
    this.markName = this.selectedItem?.saksi_keluarga_nama || "";
    this.modalMark = true;
  }

  async submitMark() {
    const fns: Record<string, Function> = {
      penyetuju: (id, payload) => PersetujuanLaparotomiSvc.markPenyetuju(id, { penyetuju_nama: payload }),
      saksi_keluarga: (id, payload) => PersetujuanLaparotomiSvc.markSaksiKeluarga(id, { saksi_keluarga_nama: payload }),
    };
    const fn = fns[this.markRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, this.markName);
    if (resp.data.status == "1") {
      this.modalMark = false;
      appModule.NoticeDelay(resp.data.message);
      this.selectedItem = null;
      storePersetujuanLaparotomi.getByRegister(this.register);
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const fns: Record<string, Function> = {
      dpjp: PersetujuanLaparotomiSvc.signDpjp,
      saksi_rs: PersetujuanLaparotomiSvc.signSaksiRs,
    };
    const labels: Record<string, string> = {
      dpjp: "DPJP",
      saksi_rs: "Saksi RS",
    };
    const fn = fns[this.signRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      this.selectedItem = null;
      storePersetujuanLaparotomi.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    PersetujuanLaparotomiSvc.print(this.selectedItem.id);
  }

  async remove() {
    if (!this.canDelete) return;
    if (!confirm("Anda yakin akan menghapus Persetujuan Laparotomi ini?")) return;
    this.deleting = true;
    try {
      const resp = await PersetujuanLaparotomiSvc.destroy(this.selectedItem.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        this.selectedItem = null;
        storePersetujuanLaparotomi.getByRegister(this.register);
      }
    } finally {
      this.deleting = false;
    }
  }
}
